/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsSurchargeTimesCtrl
 * @description
 */
angular.module('mercury.modules.reports.discounts')
.controller('ReportsSurchargeTimesCtrl', ["$filter", "ReportSales", "reporttime", "$scope", "title", function($filter, ReportSales, reporttime, $scope, title) {
  title.set('Surcharge Times Report');

  $scope.loading = ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval());
  $scope.loading.then(function(results) {
    $scope.sales = results;
    angular.forEach($scope.sales, function(period) {
      period.percent = (period.invoices !== 0) ? period.surcharges / period.invoices : 0;
    });

    $scope.totalSurcharges = $filter('sumof')($scope.sales, 'surcharges');

    var totalSales = $filter('sumof')($scope.sales, 'invoices');
    $scope.averagePercent = (totalSales !== 0) ? $scope.totalSurcharges / totalSales : 0;
  });

  // Column definition for the main column graph
  $scope.surchargesGraphColums = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Amount', type: 'number', key: 'surcharges', filter: 'currency'}
  ];
}]);
